export enum ReviewTrackerStatus {
  DoNotRespond_Approved = 'Do not respond (Approved)',
  Closed_CustomerEmailedDirectly = 'Closed - Customer emailed directly',
  Closed_CustomerHasBeenPhoned = 'Closed - Customer has been phoned',
  Closed_VoucherSent = 'Closed - Voucher sent',
  ClosedNoResponse = 'Closed - No response'
}
